import type { IAvailableIcons } from '@/components/v2/ui/icon'
import {
  MOCK_TRUST_CENTER_CONTROL_ICONS,
  MOCK_TRUST_CENTER_CONTROLS,
} from '@/lib/data/mocks/trust-center/trustCenterControls'
import type { ITrustCenterControl, ITrustCenterControlItem } from '@/types/trust-center/trustCenterControl'
import { generateSlug } from '../utils'

const DEFAULT_DOMAIN_ICON: IAvailableIcons = 'shield-check'

export interface IControlDomain extends ITrustCenterControl {
  slug: string
  icon: IAvailableIcons
}

export interface IControlRow extends ITrustCenterControlItem {
  domain: string
}

export const CONTROL_DOMAINS: IControlDomain[] = MOCK_TRUST_CENTER_CONTROLS.map((control) => ({
  ...control,
  slug: generateSlug(control.title),
  icon: MOCK_TRUST_CENTER_CONTROL_ICONS[control.id] ?? DEFAULT_DOMAIN_ICON,
}))

export const CONTROL_COUNT = CONTROL_DOMAINS.reduce((total, domain) => total + domain.items.length, 0)

export const toControlRows = (domains: IControlDomain[]): IControlRow[] =>
  domains.flatMap((domain) => domain.items.map((item) => ({ ...item, domain: domain.title })))

export const findControlDomain = (slug: string) => CONTROL_DOMAINS.find((domain) => domain.slug === slug)
